import StickyHeadTable from './StickyHeadTable';

export default StickyHeadTable;
